import { Store } from "./store";
import { DEFAULT_LANGUAGE, SUPPORTED_LANGUAGE } from "../constants";
import { Core } from "./core";
import { createWrapper } from "@upandgo/scorm-wrapper";
import { getNavigatorCompatibleLanguage } from "../utils/utils";

export const store = new Store(DEFAULT_LANGUAGE);
export const core = new Core(store, createWrapper, getNavigatorCompatibleLanguage, SUPPORTED_LANGUAGE);
